/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RestrictionCheckItemDTOFromJSON, RestrictionCheckItemDTOToJSON, } from './RestrictionCheckItemDTO';
/**
 * Check if a given object implements the PaginatedResponseRestrictionCheckItemDTO interface.
 */
export function instanceOfPaginatedResponseRestrictionCheckItemDTO(value) {
    return true;
}
export function PaginatedResponseRestrictionCheckItemDTOFromJSON(json) {
    return PaginatedResponseRestrictionCheckItemDTOFromJSONTyped(json, false);
}
export function PaginatedResponseRestrictionCheckItemDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'items': json['items'] == null ? undefined : (json['items'].map(RestrictionCheckItemDTOFromJSON)),
    };
}
export function PaginatedResponseRestrictionCheckItemDTOToJSON(json) {
    return PaginatedResponseRestrictionCheckItemDTOToJSONTyped(json, false);
}
export function PaginatedResponseRestrictionCheckItemDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'currentPage': value['currentPage'],
        'totalCount': value['totalCount'],
        'items': value['items'] == null ? undefined : (value['items'].map(RestrictionCheckItemDTOToJSON)),
    };
}
